import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { useAppTranslation } from '../../../../hooks/useAppTranslation'
import { Modal } from '../../../common/Modal'
import { ModalBody } from '../../../common/Modal/ModalBody'
import { ModalHeader } from '../../../common/Modal/ModalHeader'
import { ManageHouseholdModalContent } from './ManageHouseholdModalContent'
import { Spinner } from '../../../common/Spinner'
import { unitQueries } from '../../../../api/units'
import { useAuth } from '../../../../hooks/useAuth'

interface ManageHouseholdModalProps {
  show: boolean
  close: () => void
}

export const ManageHouseholdModal = ({
  show,
  close,
}: ManageHouseholdModalProps): React.ReactNode => {
  const { translate } = useAppTranslation()
  const { userId } = useAuth()
  const { isLoading } = useQuery(unitQueries.getUserUnits(userId))

  return (
    <Modal show={show} size="lg">
      {{
        header: (
          <ModalHeader onClose={close}>
            {translate('manageHousehold.modalTitle')}
          </ModalHeader>
        ),
        body: (
          <ModalBody>
            {isLoading ? (
              <div className="flex items-center justify-center">
                <Spinner />
              </div>
            ) : (
              <ManageHouseholdModalContent />
            )}
          </ModalBody>
        ),
      }}
    </Modal>
  )
}
